/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { MetricsContext } from './metricsContext';
import type { MetricsResponseFiguresItem } from './metricsResponseFiguresItem';

export interface MetricsResponse {
  context: MetricsContext;
  figures: MetricsResponseFiguresItem[];
}
